import React from 'react';
import toApp from '@xpeng/to-app';
import './index.less';

interface Props {
  title: string
  subTitle?: string
}

const OpenBar = ({ title, subTitle }: Props) => {
  const UA = navigator.userAgent || '';
  const isXPApp = /xiaopeng/i.test(UA); // 小鹏app
  const isWX = /micromessenger/i.test(UA); // 微信
  const isWXApp = isWX && /miniProgram/i.test(UA); // 微信小程序
  const isMyApp = /AliApp/i.test(UA) && /miniProgram/i.test(UA); // 支付宝小程序

  // 不在APP/小程序/微信浏览器环境下，统一显示该引导栏
  const show = !isXPApp && !isWXApp && !isMyApp && !isWX

  const openInAppWebview = () => {
    const targetUrl = encodeURIComponent(location.href)
    toApp(`activity/openurl?url=${targetUrl}`)
  }

  return (
    <>
      {
        show ? (
          <div className='open-bar-wrap'>
            <div className='info'>
              <img alt='' src={require('./assets/logo.png')} className='logo' />
              <div className='desc'>
                <div className='title'>{title}</div>
                {!!subTitle && <div className='sub-title'>{subTitle}</div>}
              </div>
            </div>
            <div className='open-app-btn' onClick={openInAppWebview}>APP打开</div>
          </div>
        ) : null
      }
    </>
  )
}

export default OpenBar